import React from "react";
import { Link } from "react-router-dom";
import PropsTypes from "prop-types";
import { getTrail } from "../../assets/Js/localStorage";

export default function SubscriptionBar({ clickHandler, trialDaysleft }) {
  return (
    <div className=" h5 text-center primaryBgColor p-3 colorWhite mb-0">
      {getTrail() === "false"
        ? `There are ${trialDaysleft} days left on your free trial${" "}`
        : `Your free trial has been ended, Please subscribe to add tracks`}
      <Link
        className="ml-2 pl-3 pr-3 pt-1 pb-1 badge-pill badge-warning colorWhite pointerCursor text-decoration-none"
        to={{
          pathname: "/dashboard/subscribe",
        }}
        onClick={clickHandler}
      >
        Subscribe Now
      </Link>
    </div>
  );
}

SubscriptionBar.propTypes = {
  clickHandler: PropsTypes.func,
  trialDaysleft:PropsTypes.string
};
